import React from "react";
import { VscTerminalLinux } from "react-icons/vsc";

function NoProduct() {
  return (
    <div className="d-flex pt-5 flex-column align-items-center">
      <VscTerminalLinux className="fs-1 mt-5" />
      <p className="fs-24 pt-2 pb-5">No Order</p>
    </div>
  );
}

export default NoProduct;
